import { getId } from 'conversations-message-history/senders/operators/getters';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function chooseThreadAssignmentMessage({
  assignorName,
  assigneeName,
  assignorSender,
  assigneeSender,
  activeAgentId
}) {
  const assignorId = assignorSender && `${getId(assignorSender)}`;
  const assigneeId = assigneeSender && `${getId(assigneeSender)}`;
  const activeAgentIsAssignor = activeAgentId === assignorId;
  const activeAgentIsAssignee = activeAgentId === assigneeId;
  if (activeAgentIsAssignor) {
    if (activeAgentIsAssignee) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'conversations-inbox-message-history.threadAssignment.activeAgentSelfAssignment',
        "data-test-id": "assignment-self"
      });
    }
    if (assigneeName) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'conversations-inbox-message-history.threadAssignment.activeAgentAssignor.default',
        options: {
          assigneeName
        },
        "data-test-id": "assignment-default"
      });
    }
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.threadAssignment.activeAgentAssignor.unknownAssignee',
      "data-test-id": "assignment-unknown"
    });
  }
  if (activeAgentIsAssignee) {
    if (assignorName) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'conversations-inbox-message-history.threadAssignment.activeAgentAssignee.default',
        options: {
          assignorName
        },
        "data-test-id": "assignee-default"
      });
    }
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.threadAssignment.activeAgentAssignee.unknownAssignor'
    });
  }
  const nonActiveAgentSelfAssignment = assignorName && assignorId === assigneeId;
  if (nonActiveAgentSelfAssignment) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.threadAssignment.activeAgentUninvolved.selfAssignment',
      options: {
        assignorName
      },
      "data-test-id": "assignment-nonactive-self"
    });
  }
  const nonActiveAgentAssignorAndAssignee = assignorName && assigneeName;
  if (nonActiveAgentAssignorAndAssignee) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.threadAssignment.activeAgentUninvolved.default',
      options: {
        assignorName,
        assigneeName
      }
    });
  }
  const nonActiveAgentAssigneeWithoutAssignor = !assignorName && assigneeName;
  if (nonActiveAgentAssigneeWithoutAssignor) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.threadAssignment.activeAgentUninvolved.unknownAssignor',
      options: {
        assigneeName
      }
    });
  }
  const nonActiveAgentAssignorWithoutAssignee = assignorName && !assigneeName;
  if (nonActiveAgentAssignorWithoutAssignee) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.threadAssignment.activeAgentUninvolved.unknownAssignee',
      options: {
        assignorName
      },
      "data-test-id": "assignment-nonactive-unknown"
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: 'conversations-inbox-message-history.threadAssignment.activeAgentUninvolved.unknownBoth'
  });
}